import React, { useState, useEffect } from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { DAY_PILLS } from "../../utils/screenAdsData";

const fmtDate = (d) => (d ? moment(d, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD") : "—");
const fmtHour = (h) => (h ? moment(h, "HH:mm").format("HH:mm") : null);

const RulesPanel = ({ rules }) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [rules]);

  if (!rules || rules.length === 0) {
    return (
      <div className="rulesPanel rulesPanel--empty">
        <div className="rulesPanel__empty-inner">
          <Icon type="inbox" />
          <span className="rulesPanel__empty-text">{t("There are no rules applied to this ad")}</span>
        </div>
      </div>
    );
  }

  const rule = rules[Math.min(index, rules.length - 1)];

  return (
    <div className="rulesPanel">
      <div className="rulesPanel__box">
        <div className="rulesPanel__head">
          <span className="rulesPanel__title">{t("Condition")}</span>
          <span className="rulesPanel__rule">
            {t("Rule")}-{index + 1}
          </span>
        </div>

        <div className="rulesPanel__label">{t("Dates")}:</div>
        <div className="rulesPanel__dates">
          <span className="rulesPanel__input">{fmtDate(rule.fromDate)}</span>
          <Icon type="arrow-right" className="rulesPanel__sep" />
          <span className="rulesPanel__input rulesPanel__input--icon">
            {fmtDate(rule.toDate)}
            <Icon type="calendar" />
          </span>
        </div>

        <div className="rulesPanel__label">{t("Days of the week")}:</div>
        <div className="rulesPanel__days">
          {DAY_PILLS.map((d) => {
            const on = rule.days.indexOf(d.value) !== -1;
            return (
              <span key={d.value} className="rulesPanel__day">
                <span className={`rulesPanel__check${on ? " rulesPanel__check--on" : ""}`}>
                  {on && <Icon type="check" />}
                </span>
                {t(d.key)}
              </span>
            );
          })}
        </div>

        <div className="rulesPanel__label">{t("Hours")}:</div>
        <div className="rulesPanel__hours">
          <span className="rulesPanel__input rulesPanel__input--icon">
            {rule.fromHour ? fmtHour(rule.fromHour) : "00:00"}
            <Icon type="clock-circle" />
          </span>
          <span className="rulesPanel__input rulesPanel__input--icon">
            {rule.toHour ? fmtHour(rule.toHour) : "23:59"}
            <Icon type="clock-circle" />
          </span>
        </div>
      </div>

      <div className="rulesPanel__pager">
        <button
          type="button"
          className="screenAd__arrow"
          disabled={index === 0}
          onClick={() => setIndex((i) => Math.max(0, i - 1))}
        >
          <Icon type="left" />
        </button>
        <span className="rulesPanel__pager-label">
          {t("Rule")} {index + 1} {t("of")} {rules.length}
        </span>
        <button
          type="button"
          className="screenAd__arrow"
          disabled={index === rules.length - 1}
          onClick={() => setIndex((i) => Math.min(rules.length - 1, i + 1))}
        >
          <Icon type="right" />
        </button>
      </div>
    </div>
  );
};

export default RulesPanel;
